<shd-sidebar #configuratorSidebar>
    <ng-template shdSidebarContent>
        @if (selectedItem) {
        <div class="configurator-detail-bar">
            <div class="configurator-detail-bar-content webkit-scrollbar">
                <div class="module-image card-background-image mb-3" [ngClass]="selectedItem.name"></div>
                <h2 class="mb-3">{{ 'PORTAL_' + (selectedItem?.name | uppercase) + '_DISPLAYNAME' | translate }}</h2>
                @if (isDraft) {
                <div class="product-card-banner info mb-3 w-auto">
                    {{ 'DRAFT_TITLE' | translate }} {{ selectedItem.infos | humanlyDate : true | async }}
                </div>
                }
                <p [innerHTML]="'PORTAL_' + (selectedItem?.name | uppercase) + '_DESCRIPTION' | translate"></p>
                @if(banner[selectedItem.name]) {
                <shd-cross-selling-banner
                    [title]="banner[selectedItem.name].bannerTitle"
                    [image]="banner[selectedItem.name].image"
                    [link]="banner[selectedItem.name].webLink"
                    [inSidebar]="true"></shd-cross-selling-banner>
                }
            </div>
            <div class="configurator-detail-bar-footer">
                <a class="btn btn-success" (click)="forwardIfAllowed()">
                    @if (isPlanning()) {
                    {{
                        (selectedItemAsPlanning.isPlanned
                            ? 'SHARED_GO_TO_OVERVIEW'
                            : isDraft
                            ? 'SHARED_CONTINUE_DRAFT'
                            : 'SHARED_START_CONFIGURATOR'
                        ) | translate
                    }}
                    } @else {
                    {{ (isDraft ? 'SHARED_CONTINUE_DRAFT' : 'SHARED_START_CONFIGURATOR') | translate }}
                    }
                    <fa-icon class="ms-2" [icon]="['fal', 'arrow-right']" size="lg"></fa-icon>
                </a>
            </div>
        </div>

        }
    </ng-template>
</shd-sidebar>
